declare global {
  interface Window {
    _env_: {
      VITE_API_URL: string;
      VITE_API_SECRET_TOKEN: string;
    }
  }
}

export const config = {
    API_URL: window._env_?.VITE_API_URL || import.meta.env.VITE_API_URL || "https://api.buyfors.com",
    API_SECRET_TOKEN: window._env_?.VITE_API_SECRET_TOKEN || import.meta.env.VITE_API_SECRET_TOKEN || "gahkemuasai7cheimohShah4ush5Shie2osoh4hahl7iewaeT1"
};
